(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const burger = $("[data-burger]");
  const mobileNav = $("[data-mobile-nav]");
  burger?.addEventListener("click", () => {
    mobileNav?.classList.toggle("is-open");
    burger.setAttribute("aria-expanded", mobileNav?.classList.contains("is-open") ? "true" : "false");
  });

  const search = $("[data-search]");
  $$("[data-search-open]").forEach((btn) =>
    btn.addEventListener("click", () => {
      search?.classList.add("is-open");
      search?.querySelector("input")?.focus();
    })
  );
  $$("[data-search-close]").forEach((btn) =>
    btn.addEventListener("click", () => search?.classList.remove("is-open"))
  );
  search?.addEventListener("click", (e) => {
    if (e.target === search) search.classList.remove("is-open");
  });

  const drawer = $("[data-cart-drawer]");
  const backdrop = $("[data-backdrop]");
  const openCart = () => {
    drawer?.classList.add("is-open");
    backdrop?.classList.add("is-open");
    document.body.style.overflow = "hidden";
  };
  const closeCart = () => {
    drawer?.classList.remove("is-open");
    backdrop?.classList.remove("is-open");
    document.body.style.overflow = "";
  };
  $$("[data-cart-open]").forEach((btn) => btn.addEventListener("click", openCart));
  $$("[data-cart-close]").forEach((btn) => btn.addEventListener("click", closeCart));
  backdrop?.addEventListener("click", closeCart);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeCart();
      search?.classList.remove("is-open");
      mobileNav?.classList.remove("is-open");
    }
  });

  const term = $("[data-term]");
  if (term) {
    const lines = JSON.parse(term.getAttribute("data-term") || "[]");
    let i = 0;
    const render = () => {
      const line = lines[i % lines.length] || "assembling field kits";
      term.innerHTML = `<b>root@evilworks</b>:<span>~</span>$ ${line}<span class="ew-cursor"></span>`;
      i += 1;
    };
    render();
    setInterval(render, 3200);
  }

  $$("[data-qty]").forEach((wrap) => {
    const input = $("input", wrap);
    $("[data-qty-minus]", wrap)?.addEventListener("click", () => {
      input.value = Math.max(1, Number(input.value || 1) - 1);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    $("[data-qty-plus]", wrap)?.addEventListener("click", () => {
      input.value = Number(input.value || 1) + 1;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  $$("[data-swatch-group]").forEach((group) => {
    group.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-swatch]");
      if (!btn) return;
      $$("[data-swatch]", group).forEach((el) => el.classList.remove("is-on"));
      btn.classList.add("is-on");
      const input = group.querySelector("input[type=hidden]");
      if (input) {
        input.value = btn.dataset.swatch;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });

  const money = (cents, format) => {
    const value = (Number(cents) / 100).toFixed(2);
    return (format || window.theme?.moneyFormat || "${{amount}}").replace("{{amount}}", value);
  };

  const routes = window.theme?.routes || {};

  async function refreshCart() {
    if (!routes.cart_url) return;
    const cart = await fetch(`${routes.cart_url}.js`).then((r) => r.json());
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count < 1;
    });
    const body = $("[data-cart-items]");
    if (body) {
      if (!cart.items.length) {
        body.innerHTML = `<p class="ew-empty">Cart is empty. Deploy a kit.</p>`;
      } else {
        body.innerHTML = cart.items
          .map(
            (item) => `
          <div class="ew-drawer-item" style="display:grid;grid-template-columns:64px 1fr auto;gap:12px;margin-bottom:16px;">
            <img src="${item.image || ""}" alt="" width="64" height="64" style="object-fit:cover;border:1px solid var(--ew-line);">
            <div>
              <strong>${item.product_title}</strong>
              <div class="ew-card__meta">${item.variant_title || ""}</div>
              <div>${item.quantity} × ${money(item.final_price, window.theme?.moneyFormat)}</div>
            </div>
          </div>`
          )
          .join("");
      }
    }
    const total = $("[data-cart-total]");
    if (total) total.textContent = money(cart.total_price, window.theme?.moneyFormat);
  }

  document.addEventListener("submit", async (e) => {
    const form = e.target.closest("[data-product-form]");
    if (!form || !routes.cart_add_url) return;
    e.preventDefault();
    const btn = form.querySelector("[type=submit]");
    if (btn) btn.disabled = true;
    try {
      await fetch(routes.cart_add_url, { method: "POST", body: new FormData(form) });
      await refreshCart();
      openCart();
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  if (routes.cart_url) refreshCart();
})();
